<template>
  <div class="vx-row" id="vouchers">
    <div class="vx-col w-full">
      <div class="vx-card">
        <div class="vx-card__body card-body">
          <form>
            <div class="vx-row mb-4">
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  class="inputx"
                  v-model="model.code"
                  name="code"
                  :label="$t('DiscountCode')"
                  v-validate="'required'"
                />
                <span class="text-danger text-sm" v-show="errors.has('code')">{{
                  errors.first("code")
                }}</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  class="inputx"
                  v-model="model.title"
                  name="title"
                  :label="$t('Title')"
                  v-validate="'required'"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('title')"
                  >{{ errors.first("title") }}</span
                >
              </div>
            </div>

            <div class="vx-row mb-4">
              <div class="vx-col sm:w-1/2 w-full">
                <label class="vs-select--label datepicker-lb">{{
                  $t("StartDate")
                }}</label>
                <date-picker
                  v-model="model.expirationInfo.startClock"
                  type="datetime"
                  format="jYYYY-jMM-jDD HH:mm:ss"
                  display-format="jYYYY-jMM-jDD HH:mm:ss"
                  id="date-picker"
                  :label="$t('StartDate')"
                  name="startDate"
                  v-validate="'required'"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('startDate')"
                  >{{ errors.first("startDate") }}</span
                >
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <label class="vs-select--label datepicker-lb">{{
                  $t("EndDate")
                }}</label>
                <date-picker
                  v-model="model.expirationInfo.expireClock"
                  type="datetime"
                  format="jYYYY-jMM-jDD HH:mm:ss"
                  display-format="jYYYY-jMM-jDD HH:mm:ss"
                  id="date-picker"
                  :label="$t('EndDate')"
                  name="expireDate"
                  v-validate="'required'"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('expireDate')"
                  >{{ errors.first("expireDate") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-4">
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  class="inputx"
                  v-model="model.discountLimitation.minimumBasketAmount"
                  name="minAmount"
                  :label="$t('MinimumBasketAmount')"
                  v-validate="{ regex: '^([0-9]+)$', required: 'true' }"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('minAmount')"
                  >{{ errors.first("minAmount") }}</span
                >
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  class="inputx"
                  v-model="model.discountLimitation.maximumBasketAmount"
                  name="maxAmount"
                  :label="$t('MaximumBasketAmount')"
                  v-validate="{ regex: '^([0-9]+)$', required: 'true' }"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('maxAmount')"
                  >{{ errors.first("maxAmount") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-4">
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  class="inputx mb-4 mt-1"
                  v-model="
                    model.discountLimitation.minimumNumberOfItemsInBasket
                  "
                  name="minItems"
                  :label="$t('MinimumNumberOfItemsInBasket')"
                  v-validate="{ regex: '^([0-9]+)$', required: 'true' }"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('minItems')"
                  >{{ errors.first("minItems") }}</span
                >
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  class="inputx mt-1"
                  v-model="
                    model.discountLimitation.maximumNumberOfItemsInBasket
                  "
                  name="maxItems"
                  :label="$t('MaximumNumberOfItemsInBasket')"
                  v-validate="{ regex: '^([0-9]+)$', required: 'true' }"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('maxItems')"
                  >{{ errors.first("maxItems") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-4">
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  class="inputx mb-4 mt-1"
                  v-model="model.publicDiscountLimitation.totalLimit"
                  :disabled="DisabledNotInput()"
                  name="totalLimit"
                  :label="$t('TotalLimit')"
                  v-validate="{
                    regex: '^([0-9]+)$',
                    required: DisabledInput(),
                  }"
                />

                <span
                  class="text-danger text-sm"
                  v-show="errors.has('totalLimit')"
                  >{{ errors.first("totalLimit") }}</span
                >
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  :disabled="DisabledInput()"
                  class="inputx mt-1"
                  v-model="model.publicDiscountLimitation.limitPerUser"
                  name="limitPerUser"
                  :label="$t('LimitPerUser')"
                  v-validate="{
                    regex: '^([0-9]+)$',
                    required: DisabledNotInput(),
                  }"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('limitPerUser')"
                  >{{ errors.first("limitPerUser") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-4">
              <div class="vx-col sm:w-1/2 w-full">
                <label class="vs-input--label">{{
                  $t("CalculationType")
                }}</label>
                <v-select
                  label="name"
                  name="calculationType"
                  :options="calculationTypes"
                  v-model="model.discountType"
                  v-validate="{ required: true }"
                  :reduce="(x) => x.id"
                  dir="rtl"
                >
                </v-select>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('calculationType')"
                  >{{ errors.first("calculationType") }}</span
                >
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input
                  class="inputx mt-1"
                  v-model="model.discountAmount"
                  name="discountAmount"
                  :label="$t('DiscountAmount')"
                  v-validate="{ required: 'true', regex: '^([0-9]+)$' }"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('discountAmount')"
                  >{{ errors.first("discountAmount") }}</span
                >
              </div>
            </div>

            <div class="mb-4 flex">
              <vs-checkbox v-model="model.isItCalculatedForAnAmazingDiscount">{{
                $t("CalculatedForAnAmazingDiscount")
              }}</vs-checkbox>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-button
                  ref="ShowID"
                  :disabled="!disabled"
                  @click.prevent="SumbitForm()"
                  class="float-right mb-4"
                >
                  {{ $t("RegisterDiscountCode") }}
                </vs-button>
                <vs-button
                  ref="ShowID"
                  @click.prevent="CreatePopup()"
                  class="float-right mb-4 ml-5 hidden"
                >
                  <feather-icon
                    icon="PlusIcon"
                    svgClasses="h-4 w-4"
                    class="ico"
                  />

                  {{ $t("AddItem") }}
                </vs-button>
                <modify-popup-products
                  :show="isModifyPopup"
                  @finish="onfinish"
                  :modelApi="model"
                  :discountID="discountID"
                  :currentDiscount="currentDiscount"
                ></modify-popup-products>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
#vouchers #date-picker label {
  width: 115px;
}
</style>
<script>
import DataGrid from "@/components/datagrid/DataGrid";
import { mapActions } from "vuex";
import ModifyPopupProducts from "./ModifyPopupProducts.vue";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import vSelect from "vue-select";
import { Validator } from "vee-validate";
import "../../../assets/scss/vuesax-rtl/pages/_custom.scss";
const dict = {
  custom: {
    code: {
      required: "لطفا کدتخفیف را وارد نمایید.",
    },
    title: {
      required: "لطفا عنوان را وارد نمایید.",
    },
    startDate: {
      required: "لطفا تاریخ شروع را وارد نمایید.",
    },
    expireDate: {
      required: "لطفا تاریخ پایان را وارد نمایید.",
    },
    minAmount: {
      regex: "مقدار وارد شده مجاز نمی‌باشد.",
      required: "لطفا حداقل مقدار خرید وارد نمایید.",
    },
    maxAmount: {
      regex: "مقدار وارد شده مجاز نمی‌باشد.",
      required: "لطفا حداکثر مقدار خرید وارد نمایید.",
    },
    totalLimit: {
      regex: "مقدار وارد شده مجاز نمی‌باشد.",
      required: "لطفا حداقل تعداد آیتم های سبد خرید وارد نمایید.",
    },
    limitPerUser: {
      regex: "مقدار وارد شده مجاز نمی‌باشد.",
      required: "لطفا حداکثر تعداد آیتم های سبد خرید وارد نمایید.",
    },
    minItems: {
      regex: "مقدار وارد شده مجاز نمی‌باشد.",
      required: "لطفا حداکثر استفاده  وارد نمایید.",
    },
    maxItems: {
      regex: "مقدار وارد شده مجاز نمی‌باشد.",
      required: "لطفا حداکثر استفاده کاربر  وارد نمایید.",
    },
    calculationType: {
      required: "لطفا نوع محاسبه را انتخاب نمایید.",
    },
    discountAmount: {
      required: "لطفا مقدار تخفیف را وارد نمایید.",
      regex: "مقدار وارد شده مجاز نمی‌باشد.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "saleManagement_PublicDiscount_Create",
  data() {
    return {
      disableOne: false,
      currentDiscount: "",
      show: "",
      discountID: "",
      disabled: true,
      isModifyPopup: false,
      calculationTypes: [
        { name: "مقداری", id: 2 },
        { name: "درصدی", id: 1 },
      ],
      model: {
        title: "",
        sponsorInfo: {
          id: 0,
        },
        expirationInfo: {
          startClock: "",
          expireClock: "",
        },
        discountLimitation: {
          minimumBasketAmount: null,
          maximumBasketAmount: null,
          minimumNumberOfItemsInBasket: null,
          maximumNumberOfItemsInBasket: null,
        },
        isItCalculatedForAnAmazingDiscount: false,
        discountType: null,
        discountAmount: null,
        code: "",
        publicDiscountLimitation: {
          totalLimit: null,
          limitPerUser: null,
        },
      },
    };
  },
  components: {
    "v-select": vSelect,
    ModifyPopupProducts,
    DataGrid,
  },
  methods: {
    ...mapActions({
      createDiscount: "voucher/createDiscount",
      removeDiscount: "voucher/removeDiscount",
    }),

    requiredInput() {
      if (this.$validator.limitPerUser) {
        return true;
      }
    },
    CreatePopup(row) {
      this.currentDiscount = row;
      this.showProductList = true;

      this.isModifyPopup = true;
      if (this.$refs.ShowID) {
        this.discountId = row.id;
      }
    },
    DisabledInput() {
      if (this.model.publicDiscountLimitation.totalLimit) {
        return true;
      } else {
        return false;
      }
    },
    DisabledNotInput() {
      if (this.model.publicDiscountLimitation.limitPerUser) {
        return true;
      } else {
        return false;
      }
    },
    SumbitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.createDiscount(this.model)
            .then((r) => {
              this.discountID = r;
              this.$swal({
                position: "center-center",
                type: "success",
                text: "کدتخفیف باموفقیت ثبت گردید!",
                showConfirmButton: false,
                timer: 5000,
              });
              this.$router.push("/PublicDiscountCodes/Index");
              this.disabled = false;
            })
            .catch((err) => {
              this.disabled = false;
            });
        }
      });
    },
    onfinish() {
      this.isModifyPopup = false;
      this.$refs.grid.renderGrid();
    },
  },
};
</script>
